//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from '@nuskin/ns-icon';
import NsSlottedDropdownItems from './NsSlottedDropdownItems.vue';

export default {
  name: 'NsSlottedDropdownModal',
  components: { NsIcon, NsSlottedDropdownItems },
  props: {
    /**
     * Error message. Will show if truthy.
     */
    errorMessage: {
      type: String,
      default: '',
    },
    /**
     * If true, the Modal is open.
     */
    open: Boolean,
    /**
     * Either the index or the value of the item that should be in selected state
     */
    selected: {
      type: [String, Number],
      default: '',
    },
    /**
     * The title displayed at the top of the modal
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Translations
     */
    translations: {
      type: Object,
      default() {
        return {};
      },
    },
    /**
     * If custom is being used
     */
    usingCustom: Boolean,
  },
  data() {
    return {
      showCustomInput: false,
    };
  },
  watch: {
    open(value) {
      if (value && this.usingCustom) {
        this.showCustomInput = true;
      }

      if (!value) {
        this.showCustomInput = false;
      }
    },
  },
  methods: {
    /**
     * Emits an event whenever an item is selected
     */
    emitSelect(value, index) {
      /**
       * Fired when a menu item is selected: function(value: string|number, index: number) => void
       *
       * @type {select}
       * @property {(string|number)} value data-value attribute of the selected item, or index
       * @property {number} index index of the selected item
       */
      this.$emit('select', value, index);
    },
    handleBack() {
      this.showCustomInput = false;
    },
    /**
     * Emits close event when v-dialog requests to be closed
     */
    handleDialogInput(isOpen) {
      if (!isOpen) {
        /**
         * Fired when v-dialog requests to be closed: function() => void
         *
         * @type {click}
         */
        this.$emit('close');
      }
    },
    handleDone() {
      this.$emit('select', this.selected);
    },
    /**
     * Sets the selection
     */
    handleSelect(value, index) {
      this.emitSelect(value, index);
      if (value === 'custom') {
        this.showCustomInput = true;
      }
    },
  },
};
